/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_RecordingInputs */

const en_settings_tab_recording = /** @type {(inputs: Settings_Tab_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording`)
};

const de_settings_tab_recording = /** @type {(inputs: Settings_Tab_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme`)
};

/**
* | output |
* | --- |
* | "Recording" |
*
* @param {Settings_Tab_RecordingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_tab_recording = /** @type {((inputs?: Settings_Tab_RecordingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_RecordingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tab_recording(inputs)
	return de_settings_tab_recording(inputs)
});